import { useState } from "react";

import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQuery } from "@tanstack/react-query";

import { InboundLayout } from "ui-components/Layout";

import { headerRender, headerValues, headerValidation } from "./do-schema";
import { detailRender, detailValues, detailValidation } from "./do-details-schema";
import DO from "./components/DO";
import { doColumns } from "./columns";

import { Success, Error_ } from "ui-components/Alert";
import { InboundSaveButton } from "ui-components/Form";

import { getDO, editDO } from "services/data.outbound.service";
import { InboundHeaderCard } from "ui-components/Layout";
import { getTotalQuantity, cancelDetail } from "layouts/views/inbound/common/common";
import BasicViewTable from "ui-components/tables/BasicViewTable";
import { FormTitle } from "ui-components/Form";
const statusLabel = { D: "Open", C: "Cancel" };

function EditDO() {
  const location = useLocation();
  const { delOrderId } = location.state;
  const [formValues, setFormValues] = useState(headerValues);
  const [alert, setAlert] = useState(null);
  const [details, setDetails] = useState([]);

  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const EditDOMutation = useMutation(editDO, {});
  const navigate = useNavigate()

  useQuery({
    queryKey: ["do", { delOrderId }],
    queryFn: () => getDO({ delOrderId }),
    onSuccess: (data) => {
      const { doDetails, status, ...doValues } = data.data.data;
      setFormValues({ ...doValues, status: statusLabel[status] });
      setDetails(doDetails.map((d) => ({ ...d, status: statusLabel[d.status] })));
    },
    onError,
  });

  const form = useForm({
    defaultValues: formValues,
    values: formValues,
    resolver: yupResolver(headerValidation),
  });

  const {
    control,
    watch,
    formState: { errors, isSubmitting },
    setValue,
    getValues,
    trigger,
  } = form;

  const customerCode = watch("customerCode");
  const headerProps = {
    headerRender,
    customerCode,
    control,
    setValue,
    getValues,
    errors,
    mode: "EDIT",
  };

  const detailProps = { details, setDetails, values: { customerCode } };

  const onSubmit = async () => {
    window.scrollTo(0, 0);
    const isValid = await trigger();
    if (!isValid) return;

    const req = getValues();
    EditDOMutation.mutate(
      { delOrderId, req },
      {
        onSuccess: (data) => {navigate("/outbound/do",{state:{status2:"D",message:data.data.message}})},
        onError,
      }
    );
  };

  return (
    <InboundLayout lg={12}>
      {alert}
      <InboundHeaderCard>
        <form noValidate>
          <DO {...headerProps} />
        </form>
      </InboundHeaderCard>

      <Detail {...detailProps} />
      <InboundSaveButton
        url="/outbound/do"
        onClick={onSubmit}
        disabled={isSubmitting}
        state={{ status2: "D" }}
      />
    </InboundLayout>
  );
}

const Detail = ({ details }) => {
  const totalOrderQuantity = getTotalQuantity(details, "orderQuantity");

  const totalShippedQuantity = getTotalQuantity(details, "shippedQuantity");

  const totalQuantity = getTotalQuantity(details, "quantity");

  const caption = (
    <div>
      <span>Total Rows: {details.length}</span>
      <span style={{ marginLeft: "3rem" }}>Total Order Quantity: {totalOrderQuantity}</span>
      <span style={{ marginLeft: "3rem" }}>Total Shipped Quantity: {totalShippedQuantity}</span>
      <span style={{ marginLeft: "3rem" }}>Total Quantity: {totalQuantity}</span>
    </div>
  );
  const tableProps = {
    columns: doColumns,
    rows: details,
    caption,
  };

  return (
    <InboundHeaderCard sx={{ height: "100%" }}>
      {/* <form noValidate>
        <DODetail {...detailProps} />
        {formValues !== null && (
          <MDBox display="flex" justifyContent="center">
            <MDButton variant="gradient" color="info" onClick={() => setFormValues(null)}>
              Back
            </MDButton>
          </MDBox>
        )}
      </form> */}
      <FormTitle title={"DO Detail (View only)"} />
      <BasicViewTable {...tableProps} />
    </InboundHeaderCard>
  );
};

export default EditDO;
